module.exports = __webpack_public_path__ + "static/dds-ef928ad1be106dba54c3db6d3b8694da.png";